import axios from 'axios'
import base from '../../base'
import Noty from 'noty'

export default {
  namespaced: true,
  state: {
    items: [],
    currentItem: undefined,
    status: 'done', // loading | done | error,
    currentPage: 1,
    pageSize: 10,
    totalOfPages: 0
  },
  actions: {
    async loadAll({ commit, state }, page) {
      try {
        commit('loadAllStarted', page)
        const config = {
          url: '/dashboardpbi',
          baseURL: base,
          params: { page: page, pageSize: state.pageSize }
        }

        const { data } = await axios(config)

        commit('loadAllFinished', { result: data.Result, page: data.Page })

        if (state.totalOfPages !== data.PageCount)
          commit('updateTotalOfPages', data.PageCount)
      } catch (error) {
        commit('loadAllFailed')
        new Noty({
          type: 'error',
          text: 'Erro ao carregar dashboards.',
          timeout: 5000
        }).show()
      }
    },
    async loadSingle({ commit }, id) {
      try {
        commit('loadSingleStarted')

        const config = {
          url: `/dashboardpbi/view`,
          baseURL: base,
          params: { id }
        }

        const { data } = await axios(config)

        commit('loadSingleFinished', data)
      } catch (error) {
        commit('loadSingleFailed')
        new Noty({
          type: 'error',
          text: 'Erro ao carregar dashboard.',
          timeout: 5000
        }).show()
      }
    }
  },
  mutations: {
    loadAllStarted(state) {
      state.status = 'loading'
    },
    loadAllFinished(state, payload) {
      state.items = payload.result
      state.currentPage = payload.page
    },
    loadAllError(state) {
      state.status = 'error'
    },
    loadSingleStarted(state) {
      state.status = 'loading'
    },
    loadSingleFinished(state, item) {
      state.status = 'done'
      state.currentItem = item
    },
    loadSingleError(state) {
      state.status = 'error'
    },
    updateCurrentPage(state, payload) {
      state.currentPage = payload
    },
    updateTotalOfPages(state, payload) {
      state.totalOfPages = payload
    },
    updatePageSize(state, payload) {
      state.pageSize = payload
    }
  }
}
